import { render, staticRenderFns } from "./MyJournalTickets.vue?vue&type=template&id=18576a48&scoped=true"
import script from "./MyJournalTickets.vue?vue&type=script&lang=js"
export * from "./MyJournalTickets.vue?vue&type=script&lang=js"
import style0 from "./MyJournalTickets.vue?vue&type=style&index=0&id=18576a48&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18576a48",
  null
  
)

export default component.exports